import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { map, switchMap } from 'rxjs/operators';
import { Availability, Product } from '../../types/product.type';
import { AppSettings } from '../../PRE-LOAD/app-settings';
import { Observable } from 'rxjs';
import { buildUrl } from '../../../../urls';
import { identifierModuleUrl } from '@angular/compiler';
import { AuthService } from '../../auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class EventsService {
    events: Array<Product> = [];

    imagesUrl = `${this.appSettings.sharedAssetsUrl}/${this.appSettings.apiBrand}/${environment.assets.imageDir}`;

    private apiEndpoint = buildUrl(this.appSettings.realtimeEndpointUrl, `/api/retailer/`);

    constructor(
        private httpClient: HttpClient,
        private appSettings: AppSettings,
        private authService: AuthService

    ) {
    }

    /**
     * @description Get events data
     * @returns Returns an array of hard-coded events from the local json file
     */
    public getAllEventsWithToken(token:string): Observable<Array<Product>> {
        let activeProducts;
        return this.httpClient.get(`${this.apiEndpoint}${this.appSettings.retailerId}/events`, { headers: { 'Authorization': `Bearer ${token}` } }).pipe(
            map((res: any) => {
                res.map((eventData: Product) => {
                    eventData.flattenedTags = eventData.tags.join("-")
                    eventData.isVirtual = eventData.tags.includes("Virtual");
                });

                this.events = res;
                return this.events;
            })
        );
    }

    public getAllEvents(): Observable<Array<Product>> {
        let activeProducts;

        return this.authService.getToken().pipe(switchMap((token) => {
            return this.getAllEventsWithToken(token);
        }));
    }

    public getEvent(event: string): Observable<Array<Product>> {
        let activeProducts;
        return this.getAllEvents().pipe(
            map((res: any) => {
                res.map((eventData: Product) => {
                    eventData.flattenedTags = eventData.tags.join("-")
                    eventData.isVirtual = eventData.tags.includes("Virtual");
                });

                this.events = res;

                return this.events.filter(element => element.tags.includes(event));
            })
        );
    }

}
